var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-icon',[_vm._v(" mdi-clock-outline ")]),_c('strong',[_vm._v(" "+_vm._s(_vm.padZero(_vm.minutes))+":"+_vm._s(_vm.padZero(_vm.seconds))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }